module.exports = __webpack_public_path__ + "static/rcep-efdd7a3cb3fc8b27ec96c495a8cc1b73.png";